/*
 * @Author: amywulan
 * @Date: 2021-07-Mo 11:41:54
 * @Last Modified by:  amywulan
 * @Last Modified time: 2021-07-Mo 11:41:54
 * @description: 存放管理所有页面路由
 */
import { requireSubRoutes } from '@/utils/requireContext';
// 深度搜索routes下的js文件
const autoInjectRoutes = requireSubRoutes(
  require.context('./modules/', true, /\.js$/)
);

export default [
  {
    path: '/',
    name: 'address',
    meta: {
      hideHeader: true,
      hideQuickEntrance: true,
      signOutNoBackFeed: true,
      showFooter: true,
      notCheckPl: true,
      loginWithoutVerification: true,
    },
    component: () => import( /* webpackChunkName: "address" */ '@/views/Address/index')
  },
  {
    path: '/400',
    name: 'error400',
    component: () => import( /* webpackChunkName: "errorPage" */ '@/views/errorPage/index'),
    meta: {
      showFooter: true,
      notCheckPl: true,
      loginWithoutVerification: true,
    },
  },
  // autoInjectRoutes
  ...autoInjectRoutes,
  // ...others
  {
    path: '*',
    component: () => import( /* webpackChunkName: "feed" */ '@/views/Feed/index'),
    meta: {
      title: '首页',
      keepAlive: true,
      signOutNoBackFeed: true,
      showSearch:true,
      showFooter: true,
      loginWithoutVerification: true,
    },
  },
];
